import React from "react";
import AudioPlayer from "react-h5-audio-player";

interface AudioFileProps {
  url?: string;
}

const AudioFile: React.FC<AudioFileProps> = ({ url = "" }) => (
  <div className="text-center">
    <AudioPlayer src={url} />
  </div>
);

export default AudioFile;
